import React, { useEffect, useState } from 'react'
import { Card, Modal } from 'react-bootstrap';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { useDispatch, useSelector } from 'react-redux';
import { getConnectedAccountBalanceByIdApi } from '../../service/api/paymentGateway/getConnectedAccountBalanceById';
import { getPaymentListApi } from '../../service/api/paymentGateway/getPaymentList';
import { getConnectedAccountStatusById } from '../../service/api/paymentGateway/getConnectedAccountStatusById';
import { getPayoutListById } from '../../service/api/paymentGateway/getPayoutListById';
import { getConnectedAccountBalanceTransactionListByIdApi } from '../../service/api/paymentGateway/getConnectedAccountBalanceTransactionListById';
import InputField from '../../jsx/components/fields/inputField';
import { createPayoutApi } from '../../service/api/paymentGateway/createPayout';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import { createTransferApi } from '../../service/api/paymentGateway/createTransfer';
import { getEarningsInformationApi } from '../../service/api/paymentGateway/getEarningsInformation';

const EarningsCopy = () => {
    const { connectedAccountId, impersinateFlag } = useSelector((state) => state.user);

    const dispatch = useDispatch();

    const [availableBalanceObj, setAvailableBalanceObj] = useState({});
    // last earning paymentList[0].amount
    const [paymentList, setPaymentList] = useState([]);
    const [totalEarning, setTotalEarning] = useState(0);
    const [totalFees, setTotalFees] = useState(0);

    // Last withdrawal payoutList[0].amount
    const [payoutList, setPayoutList] = useState([]);
    const [distinationAccId, setDistinationAccId] = useState('');

    const [connectedAccStatus, setConnectedAccStatus] = useState(false);
    const [cardPaymentsCheck, setCardPaymentsCheck] = useState(false);
    const [transfersCheck, setTransfersCheck] = useState(false);

    const [connectedAccsArr, setConnectedAccsArr] = useState([]);
    const [withdrawalAmount, setWithdrawalAmount] = useState(``);
    const [isWithdrawalAmountErr, setIsWithdrawalAmountErr] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [apiResponce, setApiResponse] = useState(false);
    const [paymentListArr, setPaymentListArr] = useState([])
    const [pendingTransferModal, setPendingTransferModal] = useState(false)
    const [isTransferApiCall, setIsTransferApiCall] = useState(false)
    const hanldeWithdrawalAmount = (e) => {
        setIsWithdrawalAmountErr(false)
        setWithdrawalAmount(e.target.value.replace(/[^\d.]/g, ''));
    }

    const handleWithdrawalAmountBlurCheck = () => {
        if (isNaN(withdrawalAmount) || withdrawalAmount === '') {
            setIsWithdrawalAmountErr(true);
        }
    }

    const handleCreatePayoutFn = (e) => {
        e?.preventDefault();
        setApiResponse(true);
        if (isNaN(withdrawalAmount) || withdrawalAmount === '') {
            setIsWithdrawalAmountErr(true);
            setApiResponse(false);

        } else {
            let details = new FormData();

            details.append("user_id_ids", localStorage.getItem("user_id"));
            details.append("payout_amount_in_cents", parseInt(withdrawalAmount * 100));
            details.append("connected_account_id_ids", connectedAccountId);
            details.append("destination_id_ids", distinationAccId);

            dispatch(
                createPayoutApi(
                    details,
                    (res) => {
                        // console.log(res)
                        setApiResponse(false);
                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        handleCloseGetPayoutModal();

                        getConnectedAccountBalanceByIdFn();

                        let data = {
                            connected_account_id_ids: connectedAccountId,
                            destination_id_ids: res?.data?.data?.destination,
                        }

                        dispatch(
                            getPayoutListById(data,
                                (res) => {
                                    // console.log(res.data.data.data, 'ajkshdagduyd');
                                    setPayoutList(res.data.data.data)
                                },
                                (res) => {
                                    console.log(res)
                                })
                        )

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);


                    },
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message)
                        setToasterType("error");

                        setApiResponse(false);

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            )
        }

    }


    const getConnectedAccountBalanceByIdFn = () => {
        let data = {
            connected_account_id_ids: connectedAccountId,
        }
        dispatch(
            getConnectedAccountBalanceByIdApi(data,
                (res) => {
                    // console.log(res.data.data);
                    setAvailableBalanceObj(res.data.data)
                },
                (res) => {
                    console.log(res)
                })
        )
    }

    const getPaymentListFn = () => {
        let data = {
            connected_account_id_ids: connectedAccountId,
        }
        dispatch(
            getPaymentListApi(data,
                (res) => {
                    setPaymentListArr(res.data.data.data)
                    // console.log(res.data.data, 'payment list');
                    setPaymentList(res?.data?.data?.data)
                },
                (res) => {
                    console.log(res)
                })
        )
    }

    useEffect(() => {
        if (connectedAccountId) {
            getConnectedAccountBalanceByIdFn();
            getPaymentListFn();

            getConnectedAccountStatus();

        }
    }, []);

    useEffect(() => {
        if (paymentList?.length > 0) {
            let total = 0;
            paymentList?.map((element) => {
                total += element?.meta_data?.amount
            })
            setTotalEarning(total / 100)

            setTotalFees(paymentList?.length * 3);
        }
    }, [paymentList])

    // useEffect(() => {
    //     if (connectedAccountId) {
    //         getConnectedAccountStatus();
    //     }
    // }, [])

    const getConnectedAccountStatus = () => {
        let details = {
            connected_account_id_ids: connectedAccountId,
        }
        dispatch(
            getConnectedAccountStatusById(details,
                (res) => {
                    // console.log(res?.data?.data)
                    // console.log(res?.data?.data?.connected_account_status)
                    setConnectedAccStatus(res?.data?.data?.connected_account_status)
                    if (res?.data?.data?.connected_account_details.capabilities.card_payments === "active") { setCardPaymentsCheck(true) }
                    if (res?.data?.data?.connected_account_details.capabilities.transfers === "active") { setTransfersCheck(true) }

                    setConnectedAccsArr(res?.data?.data?.connected_account_details?.external_accounts?.data);
                    // setConnectedAccBank(res?.data?.data?.connected_account_details.external_accounts.data[0].bank_name)
                    // setConnectedAccCurrency(res?.data?.data?.connected_account_details.external_accounts.data[0].currency.toUpperCase())
                    // setConnectedAccLast4(res?.data?.data?.connected_account_details.external_accounts.data[0].last4)
                    setDistinationAccId(res?.data?.data?.connected_account_details?.external_accounts.data[0].id)

                    if (
                        res?.data?.data?.connected_account_status &&
                        res?.data?.data?.connected_account_details.capabilities.card_payments === "active" &&
                        res?.data?.data?.connected_account_details.capabilities.transfers === "active"
                    ) {
                        let data = {
                            connected_account_id_ids: connectedAccountId,
                            destination_id_ids: res?.data?.data?.connected_account_details?.external_accounts.data[0].id,
                        }
                        dispatch(
                            getPayoutListById(data,
                                (res) => {
                                    // console.log(res.data.data.data, 'ajkshdagduyd');
                                    setPayoutList(res.data.data.data)
                                },
                                (res) => {
                                    console.log(res)
                                })
                        )
                    }

                    // console.log(connectedAccBank, connectedAccCurrency, connectedAccLast4)
                },
                (res) => {
                    console.log(res?.data)
                })
        )
    }

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    function convertUnixTime(unixTime) {
        // Create a new Date object from the Unix timestamp
        // Note: Unix timestamp should be in milliseconds for JavaScript Date object,
        // so we multiply by 1000 (because Unix timestamp is usually in seconds).
        const date = new Date(unixTime * 1000);

        // Define an array of month names to convert month number to month name
        const months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        // Extract the day, month and year from the date
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        // Return the formatted date string
        return `${month} ${day}, ${year}`;
    }

    const [transactionList, setTransactionList] = useState([]);
    // Transaction List functions
    const [transactionListTrigger, setTransactionListTrigger] = useState(false);
    const [totalTransactionBal, setTotalTransactionBal] = useState(0);
    const handleOpenTransactionList = () => {
        setTransactionListTrigger(true);
        getConnectedAccBalanceTransactionListByIdFn();
    }
    const handleCloseTransactionList = () => {
        setTransactionListTrigger(false);
    }

    const getConnectedAccBalanceTransactionListByIdFn = () => {

        let data = {
            connected_account_id_ids: connectedAccountId,
            current_date: Math.floor(Date.now() / 1000),
            type: 'payout',
            filter_type: '',
        }
        dispatch(
            getConnectedAccountBalanceTransactionListByIdApi(data,
                (res) => {
                    // console.log(res.data.data);
                    setTransactionList(res.data.data.data)
                },
                (res) => {
                    console.log(res)
                })
        )
    }

    useEffect(() => {
        if (transactionList?.length > 0) {
            let total = 0;
            transactionList?.map((element) => {
                if (element?.amount > 0) {
                    total += element?.amount
                }
            })
            setTotalTransactionBal(total / 100)

        }
    }, [transactionList])

    // functons for the get payout to bank or debit cards
    const [getPayoutTrigger, setGetPayoutTrigger] = useState(false);

    const handleOpenGetPayoutModal = () => {
        setGetPayoutTrigger(true);
    }
    const handleCloseGetPayoutModal = () => {
        setGetPayoutTrigger(false);
        setWithdrawalAmount('')
        setIsWithdrawalAmountErr(false)
        setApiResponse(false)
    }

    const hasTimestampPassed = (timestamp) => {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return timestamp < currentTime;
    };

    function handlePendingTransferModal() {
        setPendingTransferModal(!pendingTransferModal)
    }
    function callApiCreateTransferFn(val) {
        // console.log(val)
        setIsTransferApiCall(true)
        let data = new FormData();
        data.append("amount_in_cents", val.meta_data.amount)
        data.append("payment_intent_id_ids", val.payment_intent_id_chr)
        data.append("call_log_id_ids", val.call_log_id_lng)


        dispatch(createTransferApi(data, () => {
            setIsTransferApiCall(false)
            getPaymentListFn()
        }, () => {
            setIsTransferApiCall(false)
        }))
    }

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    // new functions for the earnings
    const getEarningsInformationFn = () => {
        let details = {};
        dispatch(
            getEarningsInformationApi(
                details,
                (res) => {
                    // console.log(res.data.data)
                  
                },
                (res) => {
                    console.log(res.data.data);
                }
            )
        );
    };

    useEffect(() => {
        getEarningsInformationFn();
    }, [])
    return (
        <>
            <div className='row mx-0 w-100'>
                <div className='col-12 px-0'>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <Card className='w-100'>
                                <div className=' border col-12 mb-2 p-3 shadow-sm rounded'>
                                    <div className='row mx-0'>

                                        <div className='align-items-center col-2 col-md-2 col-sm-4 d-flex justify-content-center '>
                                            <div className='align-items-cente bg-white border d-flex fs-2 justify-content-center rounded-circle text-black' style={{ minHeight: '50px', minWidth: '50px', }}>
                                                <i class="align-self-center bi bi-gear-wide-connected"></i>
                                            </div>
                                        </div>

                                        <div className='col-10 col-md-10 col-sm-8 '>
                                            <div className=' fs-3 row mb-3'>
                                                <div className='col-12 '>
                                                    <span className='fw-500 text-black'>{"Balance: "}</span>
                                                    <span className='fw-bold text-green'>{`${USDollar.format((availableBalanceObj?.available?.[0]?.amount / 100) || 0)}`}</span>
                                                </div>

                                            </div>
                                            <div className='row fs-5 mb-3'>
                                                <div className='col-md-6'>
                                                    <span>{`Total earnings: `}</span>
                                                    <span className='fw-bold'>{`${USDollar.format(totalEarning)}`}</span>
                                                </div>

                                                <div className='col-md-6'>
                                                    <span>{`Platform fees: `}</span>
                                                    <span className='fw-bold'>{`${USDollar.format(totalFees)}`}</span>
                                                </div>

                                            </div>
                                            <div className='font-w500 row fs-7 d-flex' style={{ gap: "10px" }}>
                                                <div className='col-md-5 '
                                                    style={{
                                                        pointerEvents: connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck ? "auto" : "none",
                                                        opacity: connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck ? "1" : "0.5",
                                                    }}
                                                >
                                                    <PrimaryButton
                                                        onClick={() => { handleOpenGetPayoutModal() }}
                                                        buttonName={"Get paid now"}
                                                        style={{
                                                            width: "100%",
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        }}
                                                    />


                                                </div>
                                                <div className='col-md-5'>
                                                    <PrimaryButton
                                                        onClick={() => { handlePendingTransferModal() }}
                                                        buttonName={"Transfer funds"}
                                                        style={{
                                                            width: "100%",
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        }}
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                        {/* <div className='col-1 col-md-1 text-black'>
                                        <div className='fs-5 fw-bold row mb-1'>

                                            <div className="tooltipCustom">
                                                <span className="tooltiptextCustom w-100">{"More"}</span>
                                                <span className='d-flex align-items-center justify-content-center rounded-circle'>
                                                    <OverlayTrigger
                                            key={index}
                                            trigger="click"
                                            placement="bottom"
                                            // overlay={popover}
                                            overlay={popover(index)}
                                            rootClose={true}
                                            show={activePopover === index}
                                            onToggle={(show) => setActivePopover(show ? index : null)}
                                        >
                                                    <i onClick={() => { }} class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                    </OverlayTrigger>
                                                </span>
                                            </div>
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>

                    <div className='row mx-0 w-100'>
                        <div className='col-lg-6  px-0 pe-lg-3 ' >
                            <Card className='border card w-100' >
                                <div className='row mx-0  w-100 h-100'>
                                    <div className='col-12 d-flex flex-column justify-content-between p-4' style={{}}>
                                        <div className='row mx-0 mb-2'>
                                            <div className='align-items-center col-12 d-flex fs-3 fw-bold justify-content-center px-0 text-black'>

                                                <span>{`-${USDollar.format((payoutList[0]?.amount / 100) || 0)}`}</span>
                                            </div>
                                        </div>

                                        <div className='row mx-0 mb-2'>
                                            <div className='align-items-center col-12 d-flex fs-4 font-w500 justify-content-center px-0 text-black'>
                                                <span>{"Last withdrawal"}</span>
                                            </div>
                                        </div>


                                        <div className='row mx-0 mb-2'>
                                            <div className='align-items-center col-12 d-flex fw-bold justify-content-center px-0'>
                                                {payoutList?.length > 0 ?
                                                    <span>{`${convertUnixTime(payoutList[0]?.created || 0)}`}</span> :
                                                    <span>{`Never before`}</span>
                                                }
                                            </div>
                                        </div>







                                    </div>
                                </div>
                            </Card>
                        </div>

                        <div className='col-lg-6  px-0 ps-lg-3 ' >
                            <Card className='border card w-100' >
                                <div className='row mx-0  w-100 h-100'>
                                    <div className='col-12 d-flex flex-column justify-content-between p-4' style={{}}>
                                        <div className='row mx-0 mb-2'>
                                            <div className='align-items-center col-12 d-flex fs-3 fw-bold justify-content-center px-0 text-black'>

                                                {paymentList?.length > 0 ?
                                                    <span className='text-green'>{`+${USDollar.format((paymentList[0]?.amount / 100) || 0)}`}</span> :
                                                    <span className='text-green'>{`+$0.00`}</span>
                                                }
                                            </div>
                                        </div>

                                        <div className='row mx-0 mb-2'>
                                            <div className='align-items-center col-12 d-flex fs-4 font-w500 justify-content-center px-0 text-black'>
                                                <span>{"Last earning"}</span>
                                            </div>
                                        </div>


                                        <div className='row mx-0 mb-2'>
                                            <div className='align-items-center col-12 d-flex fw-bold justify-content-center px-0'>
                                                {paymentList?.length > 0 ?
                                                    <span>{`${convertUnixTime(paymentList[0]?.created_date_dtm || 0)}`}</span> :
                                                    <span>{`Never before`}</span>
                                                }
                                            </div>
                                        </div>

                                        <div className='row mx-0 '>

                                        </div>

                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>

                    <div className='row mx-0 '>
                        <div className='col-12 px-0'>
                            <Card className='w-100 bg-white '>
                                <div className='row mx-0 p-4 border rounded'>
                                    <div className='col-12 px-0 d-flex align-items-center justify-content-center mb-3 fs-2'>
                                        <span className='d-flex align-items-center justify-content-center rounded-circle bg-light border' style={{ height: '50px', width: '50px' }}>
                                            <i class="align-self-center bi bi-gear-wide-connected"></i>
                                        </span>
                                    </div>
                                    <div
                                        className='col-12 px-0 d-flex align-items-center justify-content-center fs-4 font-w600'
                                        style={{
                                            pointerEvents: connectedAccountId ? 'auto' : 'none',
                                            opacity: connectedAccountId ? 1 : 0.5,
                                        }}
                                    >
                                        <span
                                            className='overlay-action-btn px-2 py-1 cursor-pointer'
                                            onClick={() => { handleOpenTransactionList() }}
                                        >
                                            {"View transaction history"}
                                        </span>
                                    </div>

                                </div>
                            </Card>
                        </div>
                    </div>

                </div>

            </div>

            {/* Modal for view payment history */}
            <Modal className="fade" show={transactionListTrigger} centered>
                <Modal.Body style={{ minHeight: '40dvh', maxHeight: '70dvh' }}>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseTransactionList()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4 pb-2 border-bottom'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Transaction history"}
                                        </span>
                                    </div>
                                </div>



                                {/* View transaction history */}

                                <>
                                    <div className='mx-0 row border-bottom pb-2'>
                                        <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                            <div>
                                                <span >{`${transactionList?.length || 0} transaction`}</span>
                                            </div>

                                            <div className='font-w600'>
                                                <span className='text-black'>{`Balance: `}</span>
                                                {/* <span className='text-green'> {`${USDollar.format(totalTransactionBal)}`}</span> */}
                                                <span className='text-green'> {`${USDollar.format((availableBalanceObj?.available?.[0]?.amount / 100) || 0)}`}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='h-100 overflow-auto' style={{ maxHeight: '45dvh' }}>

                                        {transactionList?.length > 0 ?
                                            <>
                                                {
                                                    transactionList.map((element, index) => {
                                                        return (
                                                            <>
                                                                <div key={index} className='row mx-0 border-bottom py-3'>
                                                                    <div className='col-12 px-0'>
                                                                        <div className='row mx-2 mb-1'>
                                                                            <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                <div className='font-w500 text-black'>
                                                                                    {/* {element?.amount > 0 ?
                                                                                        <>
                                                                                            <span>{`Call duration charge`}</span>
                                                                                        </> :
                                                                                        <>
                                                                                            <span>{`Withdrawal to your bank account.`}</span>
                                                                                        </>
                                                                                    } */}
                                                                                    {element?.description ?
                                                                                        <>
                                                                                            <span>{element?.description}</span>
                                                                                        </> :
                                                                                        <>
                                                                                            <span>{`Withdrawal to your bank account.`}</span>
                                                                                        </>
                                                                                    }
                                                                                </div>

                                                                                <div className='font-w600 text-black'>
                                                                                    <span
                                                                                        className={`${element?.amount > 0 ? 'text-green' : 'text-black'}`}
                                                                                    >
                                                                                        {`${element?.amount > 0 ? "+" : ""}${USDollar.format(element?.amount / 100 || 0)}`}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className='row mx-2'>
                                                                            <div className='col-12 px-0 mb-1 d-flex justify-content-between align-items-center'>
                                                                                <div>
                                                                                    <span>{`${convertUnixTime(element?.created)}`}</span>
                                                                                </div>

                                                                                {/* <div>
                                                                                    <span>{`Service fee `}</span>
                                                                                    <span className='font-w600 text-black'>{`$0.00`}</span>
                                                                                </div> */}

                                                                                <div>
                                                                                    {element?.status === 'pending' &&
                                                                                        <span className='text-primary'>{'Pending'}</span>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </>
                                            :
                                            <div className='row mx-0 h-100'>
                                                <div className='col-12 px-0 h-100 d-flex justify-content-center align-items-center'>
                                                    <span>
                                                        {"No transaction history"}
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </>

                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            {/* Modal for get payout */}
            <Modal className="fade" show={getPayoutTrigger} centered>
                <Modal.Body style={{ minHeight: '40dvh', maxHeight: '70dvh' }}>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseGetPayoutModal()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4 pb-2'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Get paid now"}
                                        </span>
                                    </div>
                                </div>


                                <div>
                                    {connectedAccsArr?.map((element, index) => {
                                        return (
                                            <>
                                                <div className='row mx-0' key={index}>
                                                    <div className='col-12 mb-2 p-3 border shadow-sm'>

                                                        <div className='row mx-0'>
                                                            <div className='col-12  px-0 d-flex justify-content-between align-items-center'>
                                                                <div className='font-w600 mb-1 row text-success'>
                                                                    {element?.default_for_currency && <span>{"Primary payout method"}</span>}
                                                                </div>


                                                                <div className='fs-5 fw-bold mb-1'>

                                                                    {/* <div className="tooltipCustom">
                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"More"}</span>
                                                                        <span
                                                                            className='d-flex align-items-center justify-content-center more-option rounded-circle'
                                                                            style={{ height: '20px', width: '20px' }}
                                                                            onClick={() => {
                                                                                // handleMenuClick(element, index)
                                                                            }}
                                                                        >

                                                                            <i class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                                        </span>
                                                                    </div> */}
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className='row mx-0'>
                                                            <div className='col-12  px-0 d-flex align-items-center'>
                                                                <div className='bg-light text-black fs-2 d-flex align-items-center justify-content-center p-2' style={{ height: '50px', width: '50px' }}>
                                                                    <i className="bi bi-bank2"></i>
                                                                </div>
                                                                <div className='d-flex flex-column ps-3'>
                                                                    <div className='d-flex'>
                                                                        <span className='fw-bold text-black fs-5 pe-2'>{`${element?.bank_name}`}</span>
                                                                        <span className='fw-bold fs-6 bg-gray rounded-2 bg-light px-3 d-flex align-items-center'>{`${element?.currency?.toUpperCase()}`}</span>
                                                                    </div>

                                                                    <div className='d-flex font-w600'>
                                                                        <span>{`****${element?.last4}`}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })

                                    }
                                </div>


                                <form onSubmit={handleCreatePayoutFn}>
                                    <div>
                                        <div className='row mx-0 mt-2'>
                                            <div className='col-12 px-0 bg-light d-flex justify-content-center align-items-center p-2 fs-4'>
                                                <div>
                                                    <span className='fw-500 text-black'>{"Balance: "}</span>
                                                    <span className='fw-bold text-green'>{`${USDollar.format((availableBalanceObj?.available?.[0]?.amount / 100) || 0)}`}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row mx-0 mt-3'>
                                            <div className='col-12 px-0'>
                                                <InputField
                                                    labelName={`Amount to withdraw`}
                                                    placeholderName={`Amount to withdraw`}
                                                    value={`${withdrawalAmount}`}
                                                    onChange={hanldeWithdrawalAmount}
                                                    onBlur={handleWithdrawalAmountBlurCheck}
                                                    errorOccured={isWithdrawalAmountErr}
                                                    errorMeesage={`Please enter valid amount`}
                                                />
                                            </div>
                                        </div>

                                        <div className='row mx-0 mt-3'>
                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center '>
                                                <PrimaryButton
                                                    onClick={(e) => { handleCreatePayoutFn(e) }}
                                                    buttonName={"Get paid now"}
                                                    type={"submit"}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={apiResponce}
                                                    style={{ width: "100%", background: 'green', border: 'none' }}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            {/* TRANSFER MODAL */}

            <Modal className="fade" show={pendingTransferModal} centered>
                <Modal.Body style={{ minHeight: '40dvh', maxHeight: '70dvh' }}>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handlePendingTransferModal()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4 pb-2 border-bottom'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Pending Transfers"}
                                        </span>
                                    </div>
                                </div>



                                {/* View transaction history */}

                                <>

                                    <div className='h-100 overflow-auto' style={{ maxHeight: '45dvh' }}>

                                        {paymentListArr?.length > 0 ?
                                            <>
                                                {
                                                    paymentListArr.map((element, index) => {
                                                        return (
                                                            <>
                                                                <div key={index} className='row mx-0 border-bottom py-3'>
                                                                    <div className='col-12 px-0'>
                                                                        <div className='row mx-2 mb-1'>
                                                                            <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                <div className='font-w500 text-black'>

                                                                                    <>
                                                                                        <span>{`Transfer to your bank account.`}</span>
                                                                                    </>

                                                                                </div>

                                                                                <div className='font-w600 text-black'>
                                                                                    <span
                                                                                        className={'text-green'}
                                                                                    >
                                                                                        {`${USDollar.format(element?.meta_data.amount / 100 || 0)}`}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className='row mx-2'>
                                                                            <div className='col-12 px-0 mb-1 d-flex justify-content-end align-items-center'>
                                                                                {!hasTimestampPassed(element?.available_at_dtm) && (!element?.meta_data.paid) && <div>
                                                                                    You can transfer money after
                                                                                    <span style={{ fontWeight: 600 }}>
                                                                                        {` ${formatUnixTimestamp(element?.available_at_dtm)}`}
                                                                                    </span>
                                                                                </div>}

                                                                                {hasTimestampPassed(element?.available_at_dtm) && (!element?.meta_data.paid) && <div className='pointer transferButton' onClick={() => { callApiCreateTransferFn(element) }}>
                                                                                    <span>{`Transfer  `}</span>

                                                                                </div>}
                                                                                {(element?.meta_data.paid) && <div className=' ' >
                                                                                    <span style={{ fontWeight: 600, color: 'green' }}>{`Payment successful  `}</span>

                                                                                </div>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </>
                                            :
                                            <div className='row mx-0 h-100'>
                                                <div className='col-12 px-0 h-100 d-flex justify-content-center align-items-center'>
                                                    <span>
                                                        {"No Funds available to withdraw"}
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </>

                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

        </>
    )
}

export default EarningsCopy;